import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AppShell } from './components/layout/AppShell';
import { Overview } from './pages/Overview';
import { ReportLibrary } from './pages/ReportLibrary';
import { ReportViewer } from './pages/ReportViewer';
import { ReportBuilder } from './pages/ReportBuilder';
import { Templates } from './pages/Templates';
import { Settings } from './pages/Settings';
export function App() {
  return <AppProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route element={<AppShell data-id="element-4" />} data-id="element-3">
            <Route path="/" element={<Overview data-id="element-6" />} data-id="element-5" />
            <Route path="/reports" element={<ReportLibrary data-id="element-8" />} data-id="element-7" />
            <Route path="/reports/:reportId" element={<ReportViewer data-id="element-10" />} data-id="element-9" />
            <Route path="/builder" element={<ReportBuilder data-id="element-12" />} data-id="element-11" />
            <Route path="/templates" element={<Templates data-id="element-14" />} data-id="element-13" />
            <Route path="/settings" element={<Settings data-id="element-16" />} data-id="element-15" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-18" />} data-id="element-17" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}